import { render, staticRenderFns } from "./xtDialogWeb.vue?vue&type=template&id=19dbee44&scoped=true&"
import script from "./xtDialogWeb.vue?vue&type=script&lang=js&"
export * from "./xtDialogWeb.vue?vue&type=script&lang=js&"
import style0 from "./xtDialogWeb.vue?vue&type=style&index=0&id=19dbee44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dbee44",
  null
  
)

export default component.exports